namespace TabAurous.Production {
    export namespace BagHistoryService {
        export const baseUrl = 'Production/BagHistory';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<WIPMovementRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function BagList(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<WIPMovementRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Production/BagHistory/List",
            BagList = "Production/BagHistory/BagList"
        }

        [
            'List', 
            'BagList'
        ].forEach(x => {
            (<any>BagHistoryService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
